import React from 'react';

import Icon from '../Icon/Icon';

const LanguageSelectIcon = (props) => {
    return (
        <Icon width='64' height='64' fill='none' {...props}>
            <mask id='mask0_10455_2355' maskUnits='userSpaceOnUse' x='4' y='5' width='52' height='49'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M55.1352 35.5481L51.0249 37.7933L46.0993 34.34H42.3185L38.5155 36.3596L36.877 41.2779L37.8359 45.896L40.686 50.1203V53.4995L21.6099 53.6573L4.5 35.7004L4.5 10.3974L16.5005 5.72372L40.686 6.44005L55.6794 15.0359L55.1352 35.5481Z'
                    fill='white'
                />
            </mask>
            <g mask='url(#mask0_10455_2355)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M51.569 29.7147C51.569 40.8342 42.5549 49.8483 31.4354 49.8483C20.316 49.8483 11.3019 40.8342 11.3019 29.7147C11.3019 18.5953 20.316 9.58115 31.4354 9.58115C42.5549 9.58115 51.569 18.5953 51.569 29.7147Z'
                    stroke='#393E44'
                    strokeWidth='2.5'
                    strokeLinejoin='round'
                />
                <path d='M31.435 10.3974V49.5762' stroke='#393E44' strokeWidth='2.5' strokeLinejoin='round' />
                <path d='M51.0249 29.7147H11.8461' stroke='#393E44' strokeWidth='2.5' strokeLinejoin='round' />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M41.5019 29.7147C41.5019 40.8342 36.9949 49.8483 31.4351 49.8483C25.8752 49.8483 21.3683 40.8342 21.3683 29.7147C21.3683 18.5953 25.8752 9.58115 31.4351 9.58115C36.9949 9.58115 41.5019 18.5953 41.5019 29.7147Z'
                    stroke='#393E44'
                    strokeWidth='2.5'
                    strokeLinejoin='round'
                />
                <mask id='mask1_10455_2355' maskUnits='userSpaceOnUse' x='12' y='9' width='36' height='19'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M24.3619 10.3974L19.4645 13.5257L15.4522 16.5191L13.1611 19.8933C13.1611 19.8933 12.6626 22.0966 12.6752 22.3932C12.6877 22.69 20.0087 26.7219 20.0087 26.7219L34.0086 27.5014L46.4 21.5525L47.7603 18.2876L45.1473 14.9718L41.5026 12.574L36.2464 10.1609L30.6196 9.58115L24.3619 10.3974Z'
                        fill='white'
                    />
                </mask>
                <g mask='url(#mask1_10455_2355)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M51.569 10.3974C51.569 15.9572 42.5549 20.4642 31.4354 20.4642C20.316 20.4642 11.3019 15.9572 11.3019 10.3974C11.3019 4.83752 20.316 0.330597 31.4354 0.330597C42.5549 0.330597 51.569 4.83752 51.569 10.3974Z'
                        stroke='#393E44'
                        strokeWidth='2.5'
                        strokeLinejoin='round'
                    />
                </g>
                <mask id='mask2_10455_2355' maskUnits='userSpaceOnUse' x='13' y='32' width='36' height='19'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M21.4601 32.4355L17.0152 35.9724L13.34 39.3032L15.1776 42.0588C15.1776 42.0588 18.5385 45.3887 18.865 45.4417C19.1918 45.4951 21.6404 47.3084 21.6404 47.3084L27.8982 49.8483L35.5163 50.1203L40.9578 48.2158L44.9108 45.9527L47.7863 42.5382L48.5759 37.6049L31.9793 32.4355H21.4601Z'
                        fill='white'
                    />
                </mask>
                <g mask='url(#mask2_10455_2355)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M51.569 48.76C51.569 54.3198 42.5549 58.8268 31.4354 58.8268C20.316 58.8268 11.3019 54.3198 11.3019 48.76C11.3019 43.2001 20.316 38.6932 31.4354 38.6932C42.5549 38.6932 51.569 43.2001 51.569 48.76Z'
                        stroke='#393E44'
                        strokeWidth='2.5'
                        strokeLinejoin='round'
                    />
                </g>
            </g>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M44.2573 34.34C48.4589 34.34 51.8651 37.8123 51.8651 42.0956C51.8651 44.6258 49.8742 48.5673 45.8923 53.9203C45.7769 54.0756 45.6404 54.2136 45.4868 54.3303C44.5838 55.0168 43.3012 54.8333 42.6222 53.9203C38.6403 48.5673 36.6494 44.6258 36.6494 42.0956C36.6494 37.8123 40.0556 34.34 44.2573 34.34Z'
                fill='#00D1D2'
                stroke='#393E44'
                strokeWidth='2.5'
            />
            <circle cx='44.2126' cy='41.9192' r='2.1766' fill='#393E44' />
        </Icon>
    );
};

export default LanguageSelectIcon;
